import { useEffect, useState } from "react";
import { BsPinFill } from "react-icons/bs";

const LinkEventBox = ({
  eventName,
  filteredOdds,
  handleDataClick,
  eventId,
  handlePinclick,
  e,
}) => {
  const [pinnedMatches, setPinnedMatches] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("pinnedMatches");
      const parsed = stored ? JSON.parse(stored) : [];
      setPinnedMatches(parsed);
    } catch (err) {
      console.error("[SoccerBetting] Failed to load pinned matches:", err);
    }
  }, []);


  const handlePin = (marketId, eventId, bmOdds, event) => {
    event?.stopPropagation();
    let updatedMatches = JSON.parse(
      localStorage.getItem("pinnedMatches") || "[]"
    );
    const matchIndex = updatedMatches.findIndex((m) => m.id === eventId);

    console.log(
      `[CricketBetting] handlePin: marketId=${marketId}, eventId=${eventId}, hasBmOdds=${!!bmOdds}`
    );
    console.log(
      "[CricketBetting] Before update:",
      JSON.stringify(updatedMatches)
    );

    if (matchIndex !== -1) {
      // Unpin both markets
      console.log(`[CricketBetting] Unpinning: eventId=${eventId}`);
      updatedMatches = updatedMatches.filter((m) => m.id !== eventId);
    } else {
      // Pin both markets (if available)
      console.log(`[CricketBetting] Pinning: eventId=${eventId}`);
      const newEntry = {
        id: eventId,
        matchOdds: true,
        bookmaker: !!bmOdds, // Only true if bmOdds exists
        marketId,
        bmOdds,
        eventId,
      };
      // if (bmOdds) newEntry.bmOdds = bmOdds;
      updatedMatches.push(newEntry);
    }

    console.log(
      "[CricketBetting] After update:",
      JSON.stringify(updatedMatches)
    );
    setPinnedMatches(updatedMatches);
    localStorage.setItem("pinnedMatches", JSON.stringify(updatedMatches));
  };
  const isPinned = pinnedMatches.some(
    (m) => m.id === e?.eventId && (m.matchOdds || m.bookmaker)
  );

  return (
    <div className="link-event-box">
      {[0, 1, 2].map((index) => (
        <div className="link-event" key={index}>
          <button
            className="btn-back"
            onClick={() =>
              handleDataClick(
                eventName,
                filteredOdds?.runners[0]?.ex?.availableToBack[index]?.price,
                "Back",
                eventId
              )
            }
          >
            <b>
              {filteredOdds?.runners[0]?.ex?.availableToBack[index]?.price ||
                "--"}
            </b>
          </button>
          <button
            className="btn-lay"
            onClick={() =>
              handleDataClick(
                eventName,
                filteredOdds?.runners[0]?.ex?.availableToLay[index]?.price,
                "Lay",
                eventId
              )
            }
          >
            <b>
              {filteredOdds?.runners[0]?.ex?.availableToLay[index]?.price ||
                "--"}
            </b>
          </button>
        </div>
      ))}

      <div className="book-mark">
        <div
          className="book-mark-icon"
          onClick={(event) =>
          {
            handlePin(e?.marketId, e?.eventId, e?.bmOdds, event);

          }
          }
          style={{ backgroundColor: isPinned && "#6bbd11" }}
        >
          <BsPinFill color={isPinned && "#ffffff"} />
        </div>
      </div>
    </div>
  );
};

export default LinkEventBox;
